import * as React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import dayjs from 'dayjs';
import 'dayjs/locale/nb'; // Norwegian locale import
import './CalenderComponent.css';

// Set the default locale once at the module level
dayjs.locale('nb');

export default function CalendarComponent({
    setSelectedDate,
    selectedDate,
    setShowCalender,
    monthIndex
}) {

    // Convert selectedDate string to dayjs object if needed
    const parsedSelectedDate = React.useMemo(() => {
        if (!selectedDate) return null;
        // If already a dayjs object, return as is
        if (dayjs.isDayjs(selectedDate)) return selectedDate;
        // If string or Date, convert to dayjs
        return dayjs(selectedDate);
    }, [selectedDate]);


    // Ensure consistent reference date calculation
    const referenceDate = React.useMemo(() => (
        monthIndex !== undefined
            ? dayjs().month(monthIndex).startOf('month')
            : dayjs()
    ), [monthIndex]);

    const handleDateChange = (date) => {
        setSelectedDate(date);
        setShowCalender(false);
        console.log(dayjs(date).format('YYYY-MM-DD'));
    };

    return (
        <LocalizationProvider
            dateAdapter={AdapterDayjs}
            locale="nb" // Use BCP 47 code for Norwegian Bokmål
            adapterLocale="nb" // Explicitly set adapter locale
        >
            <DateCalendar
                onChange={handleDateChange}
                value={parsedSelectedDate}
                referenceDate={referenceDate}
                reduceAnimations // Improves stability for some locale setups
            />
        </LocalizationProvider>
    );
}